// extracted by mini-css-extract-plugin
module.exports = {"col":"TableHeadCell_col__5Ihdv","active":"TableHeadCell_active__zf03Z","icon":"TableHeadCell_icon__tXWY6"};